export const alignments = {
    center: 'center',
    left: 'left',
};
export const types = {
    informative: 'informative',
    negative: 'negative',
    notice: 'notice',
    positive: 'positive',
};
